import React from "react";
import { Link } from "react-router-dom";
import DataGrid from './data-grid';
import format from "../functions/format";
import replace from "../functions/replace";
export default class ActivityGrid extends React.Component {
  render() {
    var data = this.props.data;
    var range = this.props.range;
    if (!range) range = 'all_time';
    var columns = [{
      field: 'title',
      title: 'Name',
      cell: props => {
        var row = props.dataItem;
        var type = row.type;
        var name = row.title;
        var sanitizedName = name.replace(/ /g, '@');
        var detailLink = `/Activity/Detail/${type}/${sanitizedName}/${range}`;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
          to: detailLink
        }, format(row.title, '-')));
      }
    }, {
      field: 'type',
      title: 'Type',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, replace(row.type)));
      }
    }, {
      field: 'total',
      title: 'Total',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.total, '-', 0, '')));
      }
    }, {
      field: 'users',
      title: 'Users',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.users, '-', 0, '')));
      }
    }, {
      field: 'sessions',
      title: 'Sessions',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.sessions, '-', 0, '')));
      }
    }, {
      field: 'value',
      title: 'Value',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.value, '-')));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}